import React from "react";

import { GripVertical } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useDragHandle } from "./DataTableSortableRow";
import { CELL_ICON_CLASS } from "./dataTableStyles";

import type { JSX } from "react";

interface DataTableDragHandleProps {
  rowLabel: string;
}

function DataTableDragHandle({
  rowLabel,
}: DataTableDragHandleProps): JSX.Element {
  const { t } = useTranslation("table");
  const handle = useDragHandle();

  return (
    <button
      ref={handle?.setActivatorNodeRef}
      aria-label={t("dataTable.dragRow", { row: rowLabel })}
      className="focus-visible:ring-ring/50 inline-flex cursor-grab touch-none rounded-sm align-middle outline-none focus-visible:ring-[3px] active:cursor-grabbing"
      type="button"
      // eslint-disable-next-line react/jsx-props-no-spreading -- attributs dnd-kit
      {...handle?.attributes}
      // eslint-disable-next-line react/jsx-props-no-spreading -- écouteurs dnd-kit
      {...handle?.listeners}
    >
      <GripVertical aria-hidden="true" className={CELL_ICON_CLASS} />
    </button>
  );
}

export default DataTableDragHandle;
